import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export const NoFileList = ({ onChange }) => {
  const [open, setOpen] = useState(false);
  const [rows, setRows] = useState(null);
  const [sel, setSel] = useState(new Set());
  const load = () => api.get("/admin/nofile").then(({ data }) => setRows(data));
  useEffect(() => { if (open) load(); }, [open]);
  const toggle = (id) => setSel((s) => { const n = new Set(s); n.has(id) ? n.delete(id) : n.add(id); return n; });
  const remove = async () => {
    if (!window.confirm(`Delete ${sel.size} photo${sel.size === 1 ? "" : "s"} with no stored file from the site?`)) return;
    try {
      const { data } = await api.post("/admin/nofile/delete", { ids: [...sel] });
      toast.success(`Deleted ${data.deleted}`);
      setSel(new Set());
      await load();
      onChange?.();
    } catch (e) { toast.error(errMsg(e)); }
  };
  if (!open) return <button className="btn-outline text-sm" onClick={() => setOpen(true)} data-testid="nofile-review">Review photos with no stored file</button>;
  return (
    <div className="space-y-2" data-testid="nofile-list">
      <ul className="max-h-64 overflow-auto text-sm divide-y">
        {(rows?.items || []).map((it) => (
          <li key={it.id} className="flex items-center gap-2 py-1">
            <input type="checkbox" checked={sel.has(it.id)} onChange={() => toggle(it.id)} data-testid={`nofile-check-${it.id}`} />
            {it.thumb_url && <img src={`${process.env.REACT_APP_BACKEND_URL}${it.thumb_url}`} alt="" className="w-8 h-8 object-cover rounded" />}
            <span className="truncate">{it.original_filename}</span>
            <small className="text-neutral-500 ml-auto">{it.space}</small>
          </li>
        ))}
      </ul>
      {rows && rows.total > rows.items.length && <small className="text-neutral-500">Showing {rows.items.length} of {rows.total}</small>}
      <button className="btn-outline !text-red-700 text-sm" disabled={!sel.size} onClick={remove} data-testid="nofile-delete">Delete selected</button>
    </div>
  );
};
